import graphql__800d2ab0b4fe218c541e from "./__generated__/ReactableMeasures_reactable.graphql.js";import { useFragment } from "react-relay";
import { graphql } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";
import padStart from "lodash/padStart";

import Icon from "../../Utils/Icon";
import { useFormatMessage } from "../../Intl/Context";
import { isUnauthorized } from "../../Utils/authorizations";

const ReactableMeasures = props => {
  const reactable = useFragment(ReactableMeasures_reactable, props.reactable);

  const { hideVotes, hideComments } = props;
  const { votes, totalCommentsCount, votesMode } = reactable;
  const { votesDisplayAuthorized, votesDownAuthorized, commentsDisplayAuthorized } =
    reactable.authorizations;

  const t = useFormatMessage();
  const votesUpCountSrLabel = t(intlMessages.votesUpCountSrLabel);
  const votesDownCountSrLabel = t(intlMessages.votesDownCountSrLabel);
  const commentsCountSrLabel = t(intlMessages.commentsCountSrLabel);

  const displayVotes = !isUnauthorized(votesDisplayAuthorized) && !hideVotes;
  const displayVotesDown = !isUnauthorized(votesDownAuthorized) && !hideVotes;
  const displayComments = !isUnauthorized(commentsDisplayAuthorized) && !hideComments;

  // Do not show the module if it has nothing to display
  if (!displayVotes && !displayComments) return null;

  const votesUpCount = displayVotes && padStart(votes.up, 2, "0");
  const votesDownCount = displayVotes && padStart(votes.down, 2, "0");
  const commentsCount = displayComments && padStart(totalCommentsCount, 2, "0");

  const textClassName = props.textClassName || "text-metric";

  const className = classNames(
    "votes-count",
    "d-flex",
    "align-items-center",
    "text-align-center",
    "padding-none",
    "margin-bottom-none",
    textClassName,
    props.className
  );

  const commentsClassName = classNames("comments-count", "text-metric", "with-icon", {
    "margin-left-xs": displayVotes
  });

  const votesUpIconClassName = classNames(
    "text-success",
    "votes-count-icon",
    "margin-left-xxs",
    {
      "icon-like": votesMode === "LIKES",
      "fa fa-caret-up": votesMode === "VOTES"
    }
  );

  const votesDownIconClassName = classNames(
    "text-danger",
    "votes-count-icon",
    "margin-left-xxs",
    {
      "icon-dislike": votesMode === "LIKES",
      "fa fa-caret-down": votesMode === "VOTES"
    }
  );

  return (
    <ul className={className}>
      {displayVotes && (
        <>
          <li className="votes-count-up text-metric with-icon">
            <span className="with-icon-text">{votesUpCount}</span>
            <span className="sr-only">{votesUpCountSrLabel}</span>
            <Icon className={votesUpIconClassName} />
          </li>

          {displayVotesDown && (
            <li className="votes-count-down text-metric with-icon margin-left-xs">
              <span className="with-icon-text">{votesDownCount}</span>
              <span className="sr-only">{votesDownCountSrLabel}</span>
              <Icon className={votesDownIconClassName} />
            </li>
          )}
        </>
      )}

      {displayComments && (
        <li className={commentsClassName}>
          <span className="with-icon-text">{commentsCount}</span>
          <span className="sr-only">{commentsCountSrLabel}</span>
          <Icon className="icon-contribute text-primary votes-count-icon margin-left-xxs" />
        </li>
      )}
    </ul>
  );
};

const ReactableMeasures_reactable = graphql__800d2ab0b4fe218c541e;

export default ReactableMeasures;

const intlMessages = defineMessages({
  votesUpCountSrLabel: {
    id: "reactableMeasures.votesUpCountSrLabel",
    defaultMessage: "(votes pour)"
  },
  votesDownCountSrLabel: {
    id: "reactableMeasures.votesDownCountSrLabel",
    defaultMessage: "(votes contre)"
  },
  commentsCountSrLabel: {
    id: "reactableMeasures.commentsCountSrLabel",
    defaultMessage: "(commentaires)"
  }
});
